const BASE_TABS = {
    wizard_form__color: 'color',
    wizard_form__price: 'price',
};

/**
 * Dynamically generates a tab map based on dealer selection and offers availability.
 * @param {boolean} hasDealerSelection - Indicates if dealer selection is enabled.
 * @param {boolean} hasOffers - Indicates if offers are available.
 * @returns {Object} - The generated tab map.
 */
const generateTabMap = (hasOffers, hasDealerSelection) => {
    let tabMap = { ...BASE_TABS };

    const entries = Object.entries(tabMap);

    // Insert 'wizard_form__offers' before 'wizard_form__color' if hasOffers is true
    if (hasOffers) {
        const colorIndex = entries.findIndex(([key]) => key === 'wizard_form__color');
        const offerEntries = [['wizard_form__offers', 'offers']];
        entries.splice(colorIndex, 0, ...offerEntries);
    }

    // Insert 'wizard_form__dealer' before 'wizard_form__price' if hasDealerSelection is true
    if (hasDealerSelection) {
        const priceIndex = entries.findIndex(([key]) => key === 'wizard_form__price');
        const dealerEntries = [['wizard_form__dealer', 'dealer']];
        entries.splice(priceIndex, 0, ...dealerEntries);
    }

    tabMap = Object.fromEntries(entries);

    return Object.freeze(tabMap);
};

export default generateTabMap;
